module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAIVBMVEUAAAAQNbz0RlMQNbwNNrz3Q1H1RlT1R1P///8QNbv0RlPNktF5AAAACHRSTlMA8PCuJiaurShm1BQAAABCSURBVDjLYxicgMVwJhh0QMEqMFAPYHCciU1ilSqDJXaJZQyS2CUWMczELrFqVGJUYrBL4ErUOLMBzoyDO6sNSgAA1GH9KiQ9eRwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flag/fr@2x.png
// module id = ilDL
// module chunks = 0